module.exports = __webpack_public_path__ + "img/ico-more.65272202.svg";